// src/components/HeroSection/HeroSection.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css'; 

// --- SİLİNDİ: Statik resim import'unu kaldırıyoruz ---
// import heroBackground from '../../assets/sancakHomeImg.jpg'; 

// --- GÜNCELLENDİ: 'backgroundImageUrl' prop'u eklendi ---
function HeroSection({ pageType, title, description, showButton, backgroundImageUrl }) {
  
  // Gelen 'pageType' prop'una göre CSS sınıfını seçiyoruz
  const containerClass = pageType === 'large' ? 'hero-large' : 'hero-small';

  // --- YENİ: Stili dinamik olarak oluştur ---
  // Eğer Firebase'den bir resim URL'si geldiyse, onu kullan.
  // Gelmediyse (veya yükleniyorsa) boş bırak.
  const heroStyle = backgroundImageUrl 
    ? { backgroundImage: `url(${backgroundImageUrl})` } 
    : { backgroundColor: '#333' }; // Resim gelene kadar varsayılan koyu renk

  return (
    <div 
      className={`hero-container ${containerClass}`} 
      // --- GÜNCELLENDİ: 'style' artık dinamik 'heroStyle' objesini kullanıyor ---
      style={heroStyle} 
    >
      
      {/* Okunurluk için resmin üzerine koyu bir katman ekliyoruz */}
      <div className="hero-overlay"></div> 
      
      <div className="hero-content">
        <h1 className="hero-title">
          {title} {/* Prop'tan gelen başlık */}
        </h1>

        {description && (
          <p className="hero-description">
            {description} {/* Prop'tan gelen açıklama */}
          </p>
        )}
        
        {showButton && (
          <Link to="/urunler"> 
            <button className="hero-button">
              Ürünlerimizi Keşfet
            </button>
          </Link>
        )}
      </div>
    </div>
  );
}

export default HeroSection;